import { Redirect, useLocalSearchParams, usePathname } from 'expo-router';
import { BlenderView } from 'smoothie';

import { useActiveTheme } from '../../../common/providers/DesignSystemProvider';

export default function DesignSystemComponentPage() {
    const { component } = useLocalSearchParams<{ component: string }>();
    const [activeTheme, setActiveTheme] = useActiveTheme();
    const pathname = usePathname();

    // Use environment variables over !IS_DEV to force exclusion from prod bundles.
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    if (!component) {
        return <Redirect href="/dev/design-system" />;
    }

    return (
        <BlenderView
            componentName={component}
            theme={activeTheme}
            onToggleTheme={setActiveTheme}
            currentPath={pathname}
        />
    );
}
